<template>
  <ul class="list-reset flex">
    <li class="border-l pl-4 relative">
      <popper
        trigger="click"
        :options="{
          placement: 'bottom-end'
        }"
      >
        <div
          class="bg-white shadow-lg w-48 mt-2 border-t-2 border-black z-50"
        >
          <ul class="list-reset">
            <li class="border-b px-4 py-2">
              <p class="font-bold">
                {{ state.user.name }}
              </p>
              <p class="text-grey-600 text-sm">
                {{ state.user.email }}
              </p>
            </li>
            <li>
              <a
                :href="route('profile')"
                class="flex no-underline px-4 py-2 text-black hover:bg-grey-100"
              >
                Profile
              </a>
            </li>
            <li class="border-t">
              <a
                href="#"
                class="flex no-underline px-4 py-2 text-black hover:bg-grey-100"
                @click.prevent="logout"
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
        <button
          slot="reference"
          type="button"
          class="relative rounded-full text-sm font-bold text-center bg-primary-500 text-white w-8 h-8 p-0 focus:outline-none focus:bg-primary-700"
        >
          {{ state.user.name[0] }}
          <icon
            icon="cheveron-down-circle"
            class="absolute pin-b pin-r w-4 h-4 icons-primary -mb-px -mr-2"
          />
        </button>
      </popper>
    </li>
  </ul>
</template>

<script>
import Popper from "vue-popperjs";
export default {
  name: "AppActions",
  components: {
    Popper
  },
  methods: {
    logout() {
      window.localStorage.clear()
      axios
        .post(route("logout"), { _token: this.state.session._token })
        .catch(() => Turbolinks.visit(route("login")));
    }
  }
};
</script>
